import { isNil } from 'lodash';

export default (params = {}) => !isNil(params.page);
